import Icon from '../Icon.vue'

Icon.register({
  'user': {
    width: 12,
    height: 12,
    paths: [
      {
        d: 'M6 0c3.308 0 6 2.692 6 6s-2.692 6-6 6c-3.309 0-6-2.692-6-6s2.691-6 6-6zm1.2 6h-.223a2.334 2.334 0 01-1.953 0H4.8A1.8 1.8 0 003 7.8v.557c0 .355.288.643.643.643h4.714A.643.643 0 009 8.357V7.8A1.8 1.8 0 007.2 6zM6 5.5a1.75 1.75 0 10.001-3.499A1.75 1.75 0 006 5.5z'
      }
    ]
  }
})
